import { makeStyles } from '@material-ui/core';

import { neutral, orange } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    padding: '1.0625rem',
    margin: 0,
    appearance: 'none',
    font: 'inherit',
    backgroundColor: neutral.white,
    border: `1px solid ${orange.D7}`,
    borderRadius: '0.625rem',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'left',
    transition: 'background-color 120ms ease, box-shadow 120ms ease',
    '&:hover': {
      backgroundColor: neutral[10],
      boxShadow: `0 0.125rem 0.5rem ${neutral.black}14`,
    },
    '&:active': {
      backgroundColor: neutral[20],
    },
    '&:focus-visible': {
      outline: `0.125rem solid ${neutral[60]}`,
      outlineOffset: '0.125rem',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '0.5rem',
  },
  identity: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  orderId: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: neutral[100],
  },
  storeName: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '0.9375rem',
    letterSpacing: '0.075rem',
    textTransform: 'uppercase',
    color: neutral[60],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    flexShrink: 0,
    padding: '0.125rem 0.625rem',
    backgroundColor: orange.D6,
    borderRadius: '1.25rem',
    color: orange[70],
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    whiteSpace: 'nowrap',
  },
  tagIcon: {
    fontSize: '1rem',
    width: '1rem',
    height: '1rem',
    color: orange[70],
  },
  dateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  dateIcon: {
    fontSize: '0.875rem',
    width: '0.875rem',
    height: '0.875rem',
    color: orange[50],
    flexShrink: 0,
  },
  dateValue: {
    margin: 0,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: neutral.D16,
  },
});
